import { Component, OnInit, Renderer2 } from '@angular/core';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { TableData } from 'src/app/shared/models/tableData';
import { JobPointeSettingsService } from 'src/app/service/job-pointe-settings/job-pointe-settings.service';
import { JobPointePermissionsService } from 'src/app/service/auth/job-pointe-permission.service';
import { JobPointeTransferService } from '../job-pointe-transfer/job-pointe-transfer.service';
import { BehaviorSubject } from 'rxjs';
import { MomentService } from 'src/app/service/shared/moment/moment.service';

@Component({
  selector: 'app-manage-jobs',
  templateUrl: './manage-jobs.component.html',
  styleUrls: ['./manage-jobs.component.scss'],
})
export class ManageJobsComponent implements OnInit {
  constructor(
    private jobPointeSettingsService: JobPointeSettingsService,
    public renderer2: Renderer2,
    private loaderService: LoaderService,
    private jobPointePermissionsService: JobPointePermissionsService,
    private JobPointeTransferService: JobPointeTransferService,
    private momentService: MomentService,
  ) {}

  private JobCardModalIsOpenSource = new BehaviorSubject<boolean>(false);
  isJobCardModalOpen = this.JobCardModalIsOpenSource.asObservable();

  private manageOwnerModalIsOpenSource = new BehaviorSubject<boolean>(false);
  isManageOwnerModalOpen = this.manageOwnerModalIsOpenSource.asObservable();

  modelDetail: any = {
    'asset-classes': {},
    categories: {},
    manufacturers: {},
    enabled: {},
  };

  data: TableData = {
    label: 'Manage Jobs',
    type: 'manageJobs',
    editAccess: true,
    selectable: true,
    statusToggle: false,
    columns: [
      {
        name: 'owner',
        label: 'Owner|Facility',
        property: row =>
          row?.potentialJobDetail?.facility && row?.potentialJobDetail?.owner
            ? `${row?.potentialJobDetail?.owner?.name} | ${row?.potentialJobDetail?.facility?.name}`
            : '',
        sortable: true,
        columnStyles: { 'max-width': '200px', cursor: 'pointer', overflow: 'hidden' },
        headerStyles: { 'min-width': '6rem' },
        columnClasses: { 'text-truncate': false },
        click: (event, row) => {
          this.JobPointeTransferService.manageOwnerModalIsOpenSource.next(row);
        },
      },
      {
        name: 'jobNumber',
        label: 'Job #',
        property: row => row?.potentialJobDetail?.number,
        sortable: true,
        columnStyles: { 'max-width': '110px', 'white-space': 'inherit' },
        headerStyles: { 'min-width': '3rem' },
        columnClasses: { 'text-truncate': false },
        click: row => false,
        tooltip: row => row.name,
        show: row => true,
        link: row => [`/jobs/${row?.potentialJobDetail?.id}`],
      },
      {
        name: 'departmentNumber',
        label: 'Dept.',
        property: row => row?.departmentNumber,
        sortable: true,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '6rem' },
        columnClasses: { 'text-truncate': false },
      },
      /* tslint:disable-next-line curly */
      {
        name: 'createdAt',
        label: 'Job Creation Date',
        property: row => this.momentService.formateDate(row?.createdAt),
        columnStyles: { 'max-width': '120px' },
        headerStyles: { 'min-width': '9rem' },
        sortable: true,
        columnClasses: { 'text-truncate': false },
      },
      {
        name: 'projectManager',
        label: 'Project Manager',
        property: row => {
          const departmentId = row.departmentId;
          return (
            row.potentialJobDetail?.potentialJobs.find(el => el.projectManager?.employeeDepartmentId === departmentId)
              ?.projectManager?.employeeAlias ?? row?.projectManager
          );
        },
        sortable: true,
        columnStyles: {
          'min-width': '100px',
          'max-width': '8%',
          'white-space': 'inherit',
          overflow: 'hidden'
        },
        headerStyles: { 'min-width': '8rem' },
        columnClasses: { 'text-truncate': false },
      },
      {
        name: 'assistant',
        label: 'Assistant',
        property: row => {
          const assistant = row.potentialJobDetail?.potentialJobs.find(el => el.assistant?.employeeAlias)?.assistant;

          const name = assistant?.employeeAlias ?? `${assistant?.firstName?.trim()} ${assistant?.lastName?.trim()}`;

          if (!name) {
            return row.assistant;
          }

          return name;
        },
        sortable: true,
        columnStyles: { 'max-width': '110px', overflow: 'hidden' },
        headerStyles: { 'min-width': '5rem', 'text-align': 'center' },
        columnClasses: { 'text-truncate': false },
      },
      {
        name: 'foreman',
        label: 'Foreman',
        property: row => row?.foreman,
        sortable: true,
        columnStyles: { 'max-width': '110px', 'text-align': '-webkit-center', overflow: 'hidden' },
        headerStyles: { 'min-width': '5rem', 'text-align': 'center' },
        columnClasses: { 'text-truncate': false },
      },
      {
        name: 'hubStatus',
        label: 'HUB Status',
        component: 'hub-status',
        property: row => row?.potentialJobDetail?.status,
        sortable: true,
        columnStyles: { 'max-width': '110px' },
        headerStyles: { 'min-width': '5rem', 'text-align': 'center' },
        columnClasses: { 'text-truncate': true },
      },
      {
        name: 'isOnJobBoard',
        label: 'Labor Board',
        property: row => row?.isOnJobBoard || row?.isSeparateOnJobBoard,
        sortable: true,
        selectable: true,
        checkboxDisabled: true,
        columnStyles: { 'max-width': '110px', 'text-align': '-webkit-center' },
        headerStyles: { 'min-width': '5rem', 'text-align': 'center' },
        columnClasses: { 'text-truncate': false },
      },
      {
        name: 'jobBoardStatus',
        label: 'Status',
        component: 'manage-jobs-status',
        property: row => row?.jobBoardStatus,
        sortable: true,
        columnStyles: { 'max-width': '110px', 'text-align': '-webkit-center' },
        headerStyles: { 'min-width': '5rem', 'text-align': 'center' },
        columnClasses: { 'text-truncate': false },
      },
    ],
    rowActions: [
      {
        label: 'Copy',
        actionId: 'openJobBoardAssignmentCard',
        imageUrl: '',
        iconName: 'fa fa-solid fa-copy',
        click: (event, row) => {},
        show: row => {
          return this.jobPointePermissionsService.isAllowed(row, 'manage_jobs', 'edit');
        },
      },
    ],
    data: [],
    pagination: {},
    meta: {},
  };

  getDefaultYears(yearsBack = 10) {
    const currentYear = new Date().getFullYear();
    const years = [...Array(yearsBack).keys()].map(i => ({
      year: currentYear - i,
    }));
    return years;
  }

  loadOptions(key: string): void {
    this.jobPointeSettingsService.read[key]().subscribe(
      res => {
        // this.loaderService.hideLoader();
        const settings = res.data.reduce((list, item) => {
          list[item.id] = item.name;
          return list;
        }, {});
        this.modelDetail[key] = settings;

        // establish the list of options for the select elements
        const filter = this.filters.find(f => f.model === key);

        // Make sure that every entry for jobAssistants has a value.
        if (key === 'jobAssistants') {
          filter.options = res.data?.filter(el => el?.assistant);
          return;
        }

        filter.options = res.data;
      },
      error => {
        console.error(error);
        this.loaderService.hideLoader();
      },
    );
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.loadSelect2();
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
  }

  filters: Array<any> = [
    {
      label: 'Project Manager',
      type: 'select2',
      propertyName: 'scope[projectManager]',
      default: '',
      value: 'employeeAlias',
      name: 'employeeAlias',
      model: 'projectManagers',
      options: [],
      loadOptions: () => this.loadOptions('projectManagers'),
    },
    {
      label: 'Assistant',
      type: 'select2',
      propertyName: 'scope[assistant]',
      default: '',
      value: 'assistant',
      name: 'assistant',
      model: 'jobAssistants',
      options: [],
      loadOptions: () => this.loadOptions('jobAssistants'),
    },
    {
      label: 'Foreman',
      type: 'select2',
      propertyName: 'scope[foreman]',
      default: '',
      value: 'foreman',
      name: 'foreman',
      model: 'jobForeman',
      options: [],
      loadOptions: () => this.loadOptions('jobForeman'),
    },
    {
      label: 'Job Status',
      type: 'select2',
      propertyName: 'scope[jobBoardStatus]',
      default: '',
      value: 'id',
      name: 'status',
      model: 'status',
      options: [
        { id: 'New Job', status: 'New Job' },
        { id: 'Hold', status: 'Hold' },
        { id: 'Active', status: 'Active' },
        { id: 'Inactive', status: 'Inactive' },
      ],
    },
    {
      label: 'Hub Status',
      type: 'select2',
      propertyName: 'scope[hubStatus]',
      default: '',
      value: 'id',
      name: 'status',
      model: 'hubStatus',
      options: [
        { id: '1', status: 'Started' },
        { id: '3', status: 'Active' },
        { id: '5', status: 'Closed' },
        { id: '0', status: 'Deleted' },
      ],
    },
    {
      label: 'Employee',
      type: 'select2',
      propertyName: 'scope[employee]',
      default: '',
      value: 'id',
      name: 'employeeAlias',
      model: 'employees',
      options: [],
      loadOptions: () => this.loadOptions('employees'),
    },
    {
      label: 'Default Start Year',
      type: 'select2',
      propertyName: 'scope[defaultStartYear]',
      default: '',
      value: 'year',
      name: 'year',
      model: 'defaultStartYear',
      options: this.getDefaultYears(),
    },
    {
      label: 'Owner',
      type: 'select2',
      propertyName: 'scope[owner]',
      default: '',
      value: 'id',
      name: 'ownerName',
      model: 'owner',
      options: [],
      loadOptions: () => this.loadOptions('owner'),
    },
  ];
}
